"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinkStyles = exports.Link = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fonts = require("../fonts");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var getLinkStyles = function getLinkStyles(_ref) {
  var theme = _ref.theme,
    color = _ref.color;
  return "\n  cursor: pointer;\n  text-decoration: none;\n  color: ".concat(color ? theme.colors[color] : theme.colors.primary, ";\n  &:hover {\n    color: ").concat(color ? theme.colors[color] : theme.colors.primary, ";\n    text-decoration: underline;\n  }\n");
};
exports.getLinkStyles = getLinkStyles;
var Link = (0, _styledComponents.default)(function (props) {
  return /*#__PURE__*/_react.default.createElement(_fonts.A, props);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), getLinkStyles);
exports.Link = Link;